import { defineStore } from 'pinia'
export const useAlertStore = defineStore('alert', {
    state: () => {
        return { alerts: []}
    },
    actions: {
        resetState() {
            this.alerts = [];
        },
        success(message) {
            this.alerts.push({
                type: "success",
                ...message
            });
        },
        error(message) {
            this.alerts.push({
                type: "danger",
                ...message
            });
        },
        info(message) {
            this.alerts.push({
                type: "info",
                ...message
            });
        },
        removeAlert(index) {
            this.alerts.splice(index, 1);
        }
    },

});
